import React from 'react'
import CommonEmailChange from '../../../common/pages/secure/EmailChange'
import Config from '../../../Config'
import PageHeader from '../../components/PageHeader'

class EmailChange extends CommonEmailChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
    this.apiUrl = Config.companyUserApiUrl.emailChange
  }
  renderPageNavi () {
    return (
      <PageHeader title='メールアドレスの変更' sub='こちらでメールアドレスを設定できます。' history={this.props.history}>
        <ul className='nav nav-pills kw-page-actions'>
          <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
        </ul>
      </PageHeader>
    )
  }
}

export default EmailChange



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EmailChange.js